import React, { useState } from 'react';
import { useWallet } from '../../context/WalletContext';
import { useUSDT } from '../../hooks/useUSDT';
import WalletModal from './WalletModal';
import NetworkBadge from './NetworkBadge';
import { fmtUSDT } from '../../utils/format';

const shortBalance = (raw) => {
  const v = parseFloat(fmtUSDT(raw).replace(/,/g, ''));
  if (!isFinite(v) || v <= 0) return '0.00';
  if (v >= 1000000) return (v / 1000000).toFixed(2) + 'M';
  if (v >= 1000) return (v / 1000).toFixed(2) + 'K';
  return v.toFixed(2);
};

const ConnectWallet = () => {
  const { account, disconnect, connecting } = useWallet();
  const { balance } = useUSDT();
  const [open, setOpen] = useState(false);

  if (!account) {
    return (
      <>
        <button className="connect-btn" onClick={() => setOpen(true)} disabled={connecting}>
          {connecting ? 'Connecting…' : 'Connect Wallet'}
        </button>
        <WalletModal open={open} onClose={() => setOpen(false)} />
      </>
    );
  }

  return (
    <div style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
      <NetworkBadge />
      <div className="wallet-balance" title={`${fmtUSDT(balance)} USDT`}>
        {shortBalance(balance)}<span className="ccy">USDT</span>
      </div>
      <button className="disconnect-x" onClick={disconnect} title="Disconnect" aria-label="Disconnect">×</button>
    </div>
  );
};

export default ConnectWallet;
